export default {
  conditionalAccess: {
    value: false,
    showToPlanType: 1,
  },
  mfa: {
    value: false,
    showToPlanType: 1,
  },
  biometric: {
    value: false,
    showToPlanType: 1,
  },
  passwordMigration: {
    selectedOption: '',
    migratePasswords: {
      migrateOption: 'sha256',
      sha256: {
        showToPlanType: 1,
      },
      sha1: { showToPlanType: 2 },
      customHashingEncryptionAlgo: {
        showToPlanType: 2,
      },
    },
    resetPassword: {
      showToPlanType: 1,
    },
  },
  otp: {
    emailOTP: {
      value: false,
      showToPlanType: 2,
    },
    choiceBetweenEmailPhone: {
      value: false,
      showToPlanType: 1,
    },
  },
  signUp: {
    attributesToCollect: {
      value: false,
      showToPlanType: 2,
    },
    collectMFA: {
      value: false,
      showToPlanType: 2,
    },
    sendWelcomeEmails: {
      value: false,
      showToPlanType: 2,
    },
    salesForceAPI: {
      value: false,
      showToPlanType: 2,
    },
    addGenericProvider: {
      value: false,
      showToPlanType: 2,
    },
  },
  enablePasswordExpiry: {
    numberOfDays: {
      value: 0,
      showToPlanType: 2,
    },
  },
  social: {
    google: {
      displayName: 'Google',
      value: false,
      linkAccounts: false,
      showToPlanType: 1,
    },
    employeeLogin: {
      displayName: 'Employee Login',
      value: false,
      linkAccounts: false,
      showToPlanType: 2,
    },
    facebook: {
      displayName: 'Facebook',
      value: false,
      linkAccounts: false,
      showToPlanType: 2,
    },
    discord: {
      displayName: 'Discord',
      value: false,
      linkAccounts: false,
      showToPlanType: 2,
    },
    linkedIn: {
      displayName: 'LinkedIn',
      value: false,
      linkAccounts: false,
      showToPlanType: 2,
    },
    wechat: {
      displayName: 'Wechat',
      value: false,
      linkAccounts: false,
      showToPlanType: 2,
    },
  },
};
